module.exports = __webpack_public_path__ + "static/media/Jack-standing 1.c6a034f8.png";